import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import isString from 'lodash/isString';
import { getTooltipTheme } from 'choerodon-ui/lib/_util/TooltipUtils';
import { Tooltip as LabelTooltip } from '../core/enum';
import isOverflow from '../overflow-tip/util';
import { hide, show } from '../tooltip/singleton';
const FormItemLabel = (props) => {
    const { className, rowSpan, paddingLeft, tooltip, children } = props;
    const tooltipRef = useRef(false);
    const style = useMemo(() => paddingLeft ? { paddingLeft } : undefined, [paddingLeft]);
    const handleMouseEnter = useCallback((e) => {
        const { currentTarget } = e;
        if (tooltip === LabelTooltip.always || (tooltip === LabelTooltip.overflow && isOverflow(currentTarget))) {
            show(currentTarget, {
                title: children,
                theme: getTooltipTheme('label'),
            });
            tooltipRef.current = true;
        }
    }, [tooltip, children, tooltipRef]);
    const handleMouseLeave = useCallback(() => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    useEffect(() => () => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    return (React.createElement("td", { className: className, rowSpan: rowSpan, style: style, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement("label", { title: isString(children) && ![LabelTooltip.always, LabelTooltip.overflow].includes(tooltip) ? children : undefined },
            React.createElement("span", null, children))));
};
FormItemLabel.displayName = 'FormItemLabel';
export default FormItemLabel;
